import HeroButton from "./HeroButton.vue";
import HeroShape from "./HeroShape.vue";
import HeroFullContent from "./HeroFullContent.vue";
import HeroSecondaryContent from "./HeroSecondaryContent.vue";
import TheHero from "./TheHero.vue";

export {
  HeroButton,
  HeroShape,
  HeroFullContent,
  HeroSecondaryContent,
}

export default TheHero;